module.exports = __webpack_public_path__ + "static/pyohio-tutorials-4-efd3d3a75a63dccfece904f748c61b3b.jpg";